import React from 'react';
import { Clinic } from './vetClinicResponse';

const VetClinicDetailsCard = ({
  clinic,
  isSearch = false,
}: {
  clinic: Clinic;
  isSearch?: boolean;
}) => (
  <>
    <h3 className="pet-form-vet-card__info--name">{clinic.name}</h3>
    {!!clinic.address &&
      !!clinic.address.city &&
      !!clinic.address.state &&
      !!clinic.address.postcode && (
        <p className="pet-form-vet-list__info">
          {!!clinic.address.street1 && <> {clinic.address.street1}</>}
          {!clinic.address.street2 ? <>, </> : <>, {clinic.address.street2}, </>}
          {!isSearch ? (
            <span className="pet-form-vet-list__info">
              {clinic.address.city}, {clinic.address.state} {clinic.address.postcode}
            </span>
          ) : (
            <>
              {clinic.address.city}, {clinic.address.state} {clinic.address.postcode}
            </>
          )}
        </p>
      )}
    {!!clinic.address && !!clinic.address.phone1 && (
      <p className="pet-form-vet-card__info--phone">
        <span>{clinic.address.phone1}</span>
      </p>
    )}
  </>
);

export default VetClinicDetailsCard;
